import React, { useMemo } from 'react';

export const  Flex = ({
  // Flex props
  alignItems,
  children,
  className,

  flexDirection,
  flexWrap,
  gap,
  // Other props
  height,

  justifyContent,
  style,
  width,
}) => {
  const styles = useMemo(
    () => ({
      alignItems,
      display: 'flex',
      flexDirection,
      flexWrap,
      gap,
      height,
      justifyContent,
      width,
      ...style,
    }),
    [],
  );

  return (
    <div className={className} style={styles}>
      {children}
    </div>
  );
}

